export default __webpack_public_path__ + "static/media/publishing-services.4e09ed58.jpg";